import { useState } from 'react';
import UI from '../../ui';
import PostsGrid from '../../components/PostsGrid';
import ShadedMap from '../../components/ShadedMap2';
import { uniq } from 'lodash';
import colors from '../../ui/colors';
import TravelerStatus from '../../components/TravelerStatus';
import { TCountryCode } from 'countries-list';
import useUser from '../../hooks/useUser';
import { user } from '../../mocks/usersMocks/usersStore';
import useUserState from '../../states/useUserState';
import { post } from '../../mocks/postsMocks/postsStore';

const Header: React.FC<{ user: user, picks: number }> = ({ user, picks }) => {
  return (
    <UI.VerticalLayout gap={5}>
      <UI.HorizontalLayout gap={10}>
        <img
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
          }}
          src={`/userImages/${user.id}.jpeg`}
        />
        <UI.VerticalLayout justify="space-between">
          <UI.Text size="title" weight="bold">{user.name}</UI.Text>
          <UI.Text>
            {user.bio}
          </UI.Text>
        </UI.VerticalLayout>
      </UI.HorizontalLayout>
      <UI.HorizontalLayout width="100%" justify="space-around">
        <UI.VerticalLayout align="center">
          <UI.Text weight="bold">{user.follower_count}</UI.Text>
          <UI.Text>Followers</UI.Text>
        </UI.VerticalLayout>
        <UI.VerticalLayout align="center">
          <UI.Text weight="bold">{user.posts.length}</UI.Text>
          <UI.Text>Pins</UI.Text>
        </UI.VerticalLayout>
        <UI.VerticalLayout align="center">
          <UI.Text weight="bold">{picks}</UI.Text>
          <UI.Text>Picks</UI.Text>
        </UI.VerticalLayout>
      </UI.HorizontalLayout>
      {/* TODO: Add Friend button should appear when viewing other users */}
      {/* <UI.Button label="Add Friend" onClick={() => {}} /> */}
    </UI.VerticalLayout>
  );
};

// const Map: React.FC<{ countries: TCountryCode[], name?: string }> = ({ countries, name }) => {
//   return (
//     <UI.VerticalLayout>
//       <TravelerStatus countries={countries} name={name} />
//       <ShadedMap selectedCountries={countries.map(country => ({ color: colors.chartreuse, countryCode: country }))} />
//     </UI.VerticalLayout>
//   );
// };

const Map: React.FC<{ countries: TCountryCode[], name?: string, posts: post[] }> = ({ countries, name, posts }) => {
  return (
    <UI.VerticalLayout>
      <TravelerStatus countries={countries} name={name} />
      <ShadedMap posts={posts} selectedCountries={countries.map(country => ({ color: colors.chartreuse, countryCode: country }))} />
    </UI.VerticalLayout>
  );
};

type mode = 'posts' | 'map';
const ProfilePage: React.FC<{ userId: string }> = ({ userId }) => {
  const [mode, setMode] = useState<mode>('posts');
  const userPage = useUser(userId);
  const userState = useUserState();
  if (!userPage) return null;
  const { user, posts } = userPage;
  const personalProfile = userState.userId === userId;
  const postsLabel = `${personalProfile ? 'my ' : ''}hotels`;
  const mapLabel = `${personalProfile ? 'my ' : ''}map`;
  return (
    <UI.VerticalLayout width="100%" overflow="scroll">
      <Header user={user} picks={posts.filter(({ pick }) => pick).length} />
      <UI.Tabs fullTabWidths options={[{ label: postsLabel, value: 'posts' }, { label: mapLabel, value: 'map' }]} onChange={setMode} value={mode} />
      {mode === 'posts' ? <PostsGrid posts={posts} /> : <Map name={personalProfile ? undefined : user.name} posts={posts} countries={uniq(posts.map(({ location }) => location.country_code))} />}
    </UI.VerticalLayout>
  );
};

export default ProfilePage;
